<template>
  <div class="modal-container modal-lg">
    <div class="modal-body">
      <div class="form_container">
        <label class="text-lg">Service List</label>
        <form action="">
          <span
            >Please check all the services listed below that applies to your
            duty.</span
          >
          <br />
          <soft-checkbox
            v-for="service_code in formData.service_list"
            :key="service_code.id"
            :id="'service-' + service_code.id"
            :value="service_code.code"
            v-model="selectedServices"
            :label="
              service_code.code + ' - ' + service_code.service_code_description
            "
            size="lg"
          />

          <soft-button
            color="success"
            size="lg"
            type="button"
            fullWidth="true"
            @click="submit_service"
          >
            Submit
          </soft-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      formData: {
        service_list: [],
      },
      selectedServices: [],
    };
  },
  props: {
    isOpen: Boolean,
    title: String,
  },
  components: {
    SoftButton,
    SoftCheckbox,
  },
  methods: {
    async fetch_service_code() {
      fetch(`${process.env.VUE_APP_BACKEND_DOMAIN}/api/service_list`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.formData.service_list = data.service_codes;
          if (data.current_service_code) {
            console.log(this.selectedServices);
            try {
              this.selectedServices = JSON.parse(data.current_service_code);
            } catch (e) {
              console.error("Invalid JSON in current_service_code:", e);
              this.selectedServices = [];
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    },
    toggleService(serviceCode) {
      if (this.selectedServices.includes(serviceCode)) {
        // remove if already selected
        this.selectedServices = this.selectedServices.filter(
          (code) => code !== serviceCode
        );
      } else {
        // insert if checked
        this.selectedServices.push(serviceCode);
      }
    },
    async submit_service() {
      if (this.selectedServices.length <= 0) return;
      Swal.fire({
        title: "Updating...",
        text: "Please wait while we update the service codes.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const formData = new FormData();
        formData.append("service_code", this.selectedServices);
        const result = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/update_service_code`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Service codes updated successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
        this.$emit("service-form-updated");

        console.log(result);
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Something went wrong while updating the service codes.",
        });
      }
    },
  },
  mounted() {
    this.fetch_service_code();
  },
};
</script>
